import { lazy, type ComponentType } from 'react';

// One retry for a stale chunk after a deploy. A second failure surfaces
// through the page error boundary instead of looping.
export function loadWithOneRetry<T>(importer: () => Promise<T>): Promise<T> {
  return importer().catch(() => importer());
}

export function lazyRoute<T extends ComponentType<any>>(importer: () => Promise<{ default: T }>) {
  return lazy(() => loadWithOneRetry(importer));
}
